import script from "./MyGamesModal.vue?vue&type=script&setup=true&lang=js"
export * from "./MyGamesModal.vue?vue&type=script&setup=true&lang=js"

import "./MyGamesModal.vue?vue&type=style&index=0&id=10c6000d&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-10c6000d"]])

export default __exports__